import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ActDialogStateService {
  private actDialogStatusSubject = new Subject<any>();

  constructor() { }

  triggerDialogStatus(data: any) {
    this.actDialogStatusSubject.next(data);
  }

  handleDialogStatus(): Observable<any> {
    return this.actDialogStatusSubject.asObservable();
  }

}




// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/act-dialog/act.dialog.contracts.state.service.ts